import { createAction } from 'redux-actions-helpers'
import { ProgressType } from '../CoursePage/types'

export const fetchModulePage = createAction(
  '@@module-page/FETCH_MODULE_PAGE',
  (id: string, moduleId: string): any => ({ id, moduleId })
)

export const fetchModulePageSuccess = createAction(
  '@@module-page/FETCH_MODULE_PAGE_SUCCESS',
  (result: any): any => ({ result })
)

export const fetchModulePageFailure = createAction(
  '@@module-page/FETCH_MODULE_PAGE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchCourseUserState = createAction(
  '@@module-page/FETCH_COURSE_USER_STATE',
  (id: string): any => ({ id })
)

export const fetchCourseUserStateSuccess = createAction(
  '@@module-page/FETCH_COURSE_USER_STATE_SUCCESS',
  (result: ProgressType): any => ({ result })
)

export const fetchCourseUserStateFailure = createAction(
  '@@module-page/FETCH_COURSE_USER_STATE_FAILURE',
  (error: string): any => ({ error })
)

export const joinLesson = createAction(
  '@@module-page/JOIN_LESSON',
  (id: string, mid: string, lid: string): any => ({ id, mid, lid })
)

export const joinLessonSuccess = createAction(
  '@@module-page/JOIN_LESSON_SUCCESS'
)

export const joinLessonFailure = createAction(
  '@@module-page/JOIN_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const joinModuleLesson = createAction(
  '@@module-page/JOIN_MODULE_LESSON',
  (id: string, mid: string, lid: string): any => ({ id, mid, lid })
)

export const joinModuleLessonSuccess = createAction(
  '@@module-page/JOIN_MODULE_LESSON_SUCCESS'
)

export const joinModuleLessonFailure = createAction(
  '@@module-page/JOIN_MODULE_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@module-page/DESTROY')
